/**
 * Vuex Store
 *
 * @requires vue
 * @requires Vuex
 */

// Dependencies
import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import { firebaseMutations } from 'vuexfire'

// Install
Vue.use(Vuex)

// Export
const store = new Vuex.Store({
	mutations: {
		...firebaseMutations
	},
	modules
})

export default store


// WEBPACK FOOTER //
// ./src/lib/store/index.js